import React, { useState } from "react";
import {
  Typography,
  Modal,
  Box,
  ImageListItem,
  Divider,
  Button,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import Close from "../../../assets/icons/Close.svg";
import GreyDownArrow from "../../../assets/icons/GreyDownArrow.svg";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "1px solid #FFFFFF",
  boxShadow: 24,
  padding: "20px 0px 20px 0px",
  borderRadius: "12px",
  outline: "none",
};

const EditRolePermissionModel = (Props) => {
  const dispatch = useDispatch();

  const userData = useSelector((state) => state?.user?.userData);
  const jsonString = localStorage.getItem("roleMastersData");
  const roleMastersData = JSON.parse(jsonString);

  const screenAccessMasterData = useSelector(
    (state) => state?.masters?.screenAccessMasterData
  );
  const [RoleType, setRoleType] = useState("");
  const [ScreenAccess, setScreenAccess] = useState("");

  const handleChangeRoleType = (event) => {
    setRoleType(event.target.value);
  };
  const handleChangeScreenAccess = (event) => {
    setScreenAccess(event.target.value);
  };

  return (
    <Modal
      open={Props.isEditRolePermissionModel}
      onClose={() => Props.handleCloseEditRolePermissionModel}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            marginBottom: "20px",
          }}
        >
          <Box sx={{ width: "90%" }}>
            <Typography
              align="center"
              sx={{
                color: "#212121",
                fontSize: "22px",
                fontWeight: 500,
                position: "relative",
                left: "35px",
              }}
            >
              Edit Role Permission Master
            </Typography>
          </Box>
          <Box
            sx={{
              width: "10%",
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              mr: 3,
            }}
          >
            <ImageListItem
              sx={{ cursor: "pointer", width: "15px" }}
              onClick={Props.handleCloseEditRolePermissionModel}
            >
              <img src={Close} alt="" />
            </ImageListItem>
          </Box>
        </Box>
        <Divider />
        <Box sx={{ padding: "20px" }}>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                mb: "20px",
              }}
            >
              <Select
                id="outlined-basic"
                variant="outlined"
                displayEmpty
                IconComponent={() => (
                  <Box
                    sx={{
                      marginRight: "10px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={GreyDownArrow}
                      alt="Custom Icon"
                      width="18"
                      height="24"
                    />
                  </Box>
                )}
                value={RoleType}
                onChange={handleChangeRoleType}
                sx={{
                  width: "50%",
                  backgroundColor: "#F3F6F9",
                  borderRadius: "10px",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                }}
              >
                <MenuItem value="" disabled>
                  Select Role
                </MenuItem>
                {roleMastersData.map((row) => (
                  <MenuItem value={row?.id}>{row?.name}</MenuItem>
                ))}
              </Select>
              <Select
                id="outlined-basic"
                variant="outlined"
                displayEmpty
                IconComponent={() => (
                  <Box
                    sx={{
                      marginRight: "10px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={GreyDownArrow}
                      alt="Custom Icon"
                      width="18"
                      height="24"
                    />
                  </Box>
                )}
                value={ScreenAccess}
                onChange={handleChangeScreenAccess}
                sx={{
                  width: "50%",
                  backgroundColor: "#F3F6F9",
                  borderRadius: "10px",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                }}
              >
                <MenuItem value="" disabled>
                  Select Screen Name
                </MenuItem>
                {screenAccessMasterData.map((row) => (
                  <MenuItem value={row?.id}>{row?.name}</MenuItem>
                ))}
              </Select>
            </Box>
          </Box>
          <Box
            sx={{
              marginTop: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "15px",
            }}
          >
            <Button
              sx={{
                fontSize: "15px",
                border: "1px solid #26875C",
                fontWeight: 600,
                width: "8rem",
                padding: "10px 5px 10px 5px",
                borderRadius: "10px",
                textTransform: "capitalize",
                color: "#26875C",
              }}
              onClick={Props.handleCloseEditRolePermissionModel}
            >
              Cancel
            </Button>

            <Button
              sx={{
                fontSize: "15px",
                fontWeight: 600,
                width: "8rem",
                border: "1px solid #26875C",
                backgroundColor: "#26875C",
                padding: "10px 5px 10px 5px",
                borderRadius: "10px",
                textTransform: "capitalize",
                color: "#FFFFFF",
                ":hover": {
                  backgroundColor: "#26875C",
                },
              }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditRolePermissionModel;
